import { render } from "./TabelaHistoricoRetirada.vue?vue&type=template&id=051aedfe&scoped=true"
import script from "./TabelaHistoricoRetirada.vue?vue&type=script&lang=js"
export * from "./TabelaHistoricoRetirada.vue?vue&type=script&lang=js"

import "./TabelaHistoricoRetirada.vue?vue&type=style&index=0&id=051aedfe&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051aedfe"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QTable,QCard,QIcon,QTr,QTh,QTd,QPagination});
